// Wiccan Tools secondary clause. Pure. No React, no Three.js.
//
// ── Codex (Wiccan Tools, Spellcaster) ──
//   "Sacrifice → Draw a spell. THIS TURN, bearer gains Spellcaster and
//   their spells require no threshold."
//
// Two transient grants on the BEARER (the minion carrying the Artifact),
// both expiring at the controller's turn end:
//   1. Spellcaster. A keyword. Granted via the shared status path so the
//      bearer becomes a valid caster; reverts through _thisTurnStatusReverts.
//   2. Threshold waiver. A per-bearer flag (`_thresholdWaiverThisTurn`)
//      read by findValidSpellcasters so element-specific casting rules are
//      skipped FOR THIS BEARER only (never globally); reverts through
//      _thisTurnThresholdWaiverReverts.
//
// This module only mutates the waiver flag and shapes the two revert-queue
// records. The orchestrator owns the status toggle (synced + badge) and the
// catalog/mesh lookups; it must capture the bearer BEFORE the Artifact is
// sacrificed, because sacrifice clears the bearer's equippedCards link.

export const SPELLCASTER_KEYWORD = 'spellcaster';

/**
 * Apply the threshold waiver to the bearer (mutates the instance) and
 * return the records the runtime queues for end-of-turn revert.
 *
 * The Spellcaster keyword is granted by the caller through the synced
 * status primitive; this returns the keyword in `statusReverts` so the
 * caller can register the matching _thisTurnStatusReverts entry.
 *
 * @param {{ id: string }} bearer the minion carrying Wiccan Tools
 * @returns {{ statusReverts: {cardId,keyword}[], waiverReverts: {cardId}[] }}
 */
export function applySpellcasterNoThresholdGrant(bearer) {
  if (!bearer) return { statusReverts: [], waiverReverts: [] };
  bearer._thresholdWaiverThisTurn = true;
  return {
    statusReverts: [{ cardId: bearer.id, keyword: SPELLCASTER_KEYWORD }],
    waiverReverts: [{ cardId: bearer.id }],
  };
}

/**
 * Clear the threshold waiver from a bearer (end-of-turn revert).
 * Idempotent. Safe to call on a bearer that never had the waiver.
 */
export function clearThresholdWaiver(bearer) {
  if (bearer) delete bearer._thresholdWaiverThisTurn;
}
